import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import Modal from '../shared/Modal';
import SelectInput from '../InputComponent/SelectInput';
import TextInput from '../InputComponent/TextInput';
import TextAreaInput from '../InputComponent/TextAreaInput';

const AssignPlanModal = ({ isOpen, onClose, onAssign, plan, users, plans }) => {
    const getTodayString = () => new Date().toISOString().split('T')[0];
    const [selectedUserId, setSelectedUserId] = useState('');
    const [selectedPlanId, setSelectedPlanId] = useState('');
    const [selectedPlan, setSelectedPlan] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [notes, setNotes] = useState('');

    useEffect(() => {
        if (isOpen) {
            setSelectedPlanId(plan?.id || (plans.length > 0 ? plans[0].id : ''));
            setSelectedUserId(users.length > 0 ? users[0].id : '');
            setStartDate('');
            setEndDate('');
            setNotes('');
        }
    }, [isOpen, plan, plans, users]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!selectedUserId) {
            toast.error('Please Select Memeber');
            return;
        } if (!selectedPlanId) {
            toast.error('Please Select a Plan.');
            return;
        } if (!startDate) {
            toast.error('Please Select the Start Date');
            return;
        }
        const selectedUser = users.find(u => u.id === selectedUserId);
        const assignedPlan = plans.find(p => p.id === selectedPlanId);

        onAssign({
            userId: selectedUserId,
            memberName: selectedUser?.name,
            planId: selectedPlanId,
            planName: selectedPlan?.name,
            startDate,
            endDate,
            notes,
        });
    };

    useEffect(() => {
        const plan = plans.find((p) => p.id === Number(selectedPlanId));
        setSelectedPlan(plan);
    }, [selectedPlanId]);
    const handleStartDate = (value) => {
        console.log("dssds", selectedPlan)
        setStartDate(value);
        calculateEndDate(value, selectedPlan)
    }

    const calculateEndDate = (start, plan) => {
        if (!start || !plan) return;

        const startObj = new Date(start);
        let endObj = new Date(startObj);

        console.log("endObj ===" + plan.access_type, endObj);
        if (plan.access_type === "month") {
            console.log("access_type ===" + plan.access_type, endObj.getMonth() + plan.duration);
            endObj.setMonth(endObj.getMonth() + plan.duration);

            const formatted = endObj.toISOString().split("T")[0];
            setEndDate(formatted);
        } else if (plan.access_type === "session") {
            endObj = startObj;
            setEndDate('');
            return;
        }

    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Assign Plan to Member">
            <form onSubmit={handleSubmit} className="space-y-4">
                <SelectInput label={"Assign Member"} value={selectedUserId} onChange={(e) => setSelectedUserId(e.target.value)} isRequired={true}>
                    <option value="">Select Member</option>
                    {users.map(user => (
                        <option key={user.id} value={user.id}>{user.name} - {user.member_id}</option>
                    ))}
                </SelectInput>

                <SelectInput label={"Assign Plan"} disabled={!!plan?.id} value={selectedPlanId} onChange={(e) => !plan?.id && setSelectedPlanId(e.target.value)} isRequired={!plan?.id}>
                    <option value="">Select Plan</option>
                    {plans.filter(p => p.status === 'active').map(p => (
                        <option key={p.id} value={p.id}>{p.name} - {p.price.toFixed(3)} OMR</option>
                    ))}
                </SelectInput>
                <div className="grid grid-cols-2 gap-4">
                    <TextInput label={"Start Date"} type="date" min={new Date().toISOString().split("T")[0]} value={startDate} onChange={(e) => handleStartDate(e.target.value)} isRequired={true} />

                    {selectedPlan?.access_type == 'month' && (
                        <TextInput label={"End Date"} disabled={true} type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                    )}
                </div>
                <TextAreaInput label={"Notes"} value={notes} onChange={(e) => setNotes(e.target.value)} rows="3" />
                <div className="pt-4 flex justify-end gap-3">
                    <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">Cancel</button>
                    <button type="submit" className="px-4 py-2 bg-brand-green text-white rounded-lg hover:bg-green-600">Assign Plan</button>
                </div>
            </form>
        </Modal>
    );
};

export default AssignPlanModal;
